var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgToastWarning = function SvgToastWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8490A0",
    fillRule: "evenodd",
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m.932-12.704a.78.78 0 1 0-1.558.001l.107 4.53a.677.677 0 0 0 1.354-.001zm-1.682 6.868c0 .504.41.914.914.914a.92.92 0 0 0 .902-.914.918.918 0 0 0-.902-.902.913.913 0 0 0-.914.902",
    clipRule: "evenodd"
  })));
};
export default SvgToastWarning;